// import "@babel/polyfill";
import "react-dates/lib/css/_datepicker.css";
import "airbnb-browser-shims";
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
